import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { resolveThemeScope } from "@/lib/theme/routes";

type RouteAwareThemeProviderProps = {
  children: ReactNode;
};

export function RouteAwareThemeProvider({
  children,
}: RouteAwareThemeProviderProps) {
  const location = useLocation();
  const themeScope = resolveThemeScope(location.pathname);

  return (
    <ThemeProvider
      key={themeScope.id}
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      forcedTheme={themeScope.forcedTheme}
      storageKey={themeScope.storageKey}
      themes={["light", "dark"]}
    >
      {children}
    </ThemeProvider>
  );
}
